import axios from "./axios";

const setSession = (accessToken, refreshToken = null) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }

  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  } else {
    localStorage.removeItem("refreshToken");
  }
};

const setProfileIdSession = (pid = null) => {
  if (pid) {
    localStorage.setItem("wp", pid);
    axios.defaults.headers.common.profileId = pid;
  } else {
    localStorage.removeItem("wp");
    delete axios.defaults.headers.common.profileId;
  }
};

export { setSession, setProfileIdSession };
